export default __webpack_public_path__ + "static/media/ic_user_cog.70823896.svg";